import {
  SAVE_EMPLOYEE_LIST,
  SAVE_EMPLOYEE_DETAILS
} from 'redux/constants/Employees';

const theme = (state = {}, action) => {
  switch (action.type) {
  case SAVE_EMPLOYEE_LIST:
    return {
      ...state,
      list: action.payload
    };
  case SAVE_EMPLOYEE_DETAILS:
    return {
      ...state,
      details: action.payload
    };
  default:
    return state;
  }
};

export default theme